import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "count"]
  static values = { max: { type: Number, default: 140 } }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasCountTarget) return
    this.countTarget.textContent = `${this.inputTarget.value.length}/${this.maxValue}`
  }
}
